import React from "react";
import Green from "../../assets/assets/green-pdf.svg";
import Grey from "../../assets/assets/grey-pdf.svg";
import Blue from "../../assets/assets/blue-pdf.svg";
import Red from "../../assets/assets/red-pdf.svg";
import Lemon from "../../assets/assets/lemon-pdf.svg";
import SandboxIcon from "../../assets/assets/sandbox.svg";
import { useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";

const Docs = ({ singleDoc, showFrame }) => {
  const history = useHistory();

  const goToProductHome = (id, link, name) => {
    if (name === "NIBSS INSTANT PAYMENT") {
      name = "NIP";
    }
    const productName = name && name.toLowerCase();
    history.push({
      pathname: `/${productName}/home`,
      state: {
        id: id,
        link: link,
        name: name,
      },
    });
  };

  return (
    <div className="pos-documentation">
      <div className="api-area">
        <div className="dashboard-main-header">
          <div className="dashboard-main-header-title2">
            <span>API Documentation</span>
          </div>
        </div>

        <div className="api-box">
          {singleDoc &&
            singleDoc.color &&
            singleDoc.color.toLowerCase() === "red" && (
              <div className="api-box-coloured red1">
                <div className="left">
                  <div className="api-box-coloured-image">
                    <img src={Red} alt="pdf" />
                  </div>
                  <div className="api-box-coloured-name">{singleDoc.name}</div>
                </div>

                <div className="right">
                  <button
                    data-testid="showFrame"
                    onClick={() =>
                      showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                    }
                    className="api-box-coloured-button"
                  >
                    view
                  </button>
                </div>
              </div>
            )}

          {singleDoc &&
            singleDoc.color &&
            singleDoc.color.toLowerCase() === "grey" && (
              <div className="api-box-coloured grey1">
                <div className="left">
                  <div className="api-box-coloured-image">
                    <img src={Grey} alt="pdf" />
                  </div>
                  <div className="api-box-coloured-name">{singleDoc.name}</div>
                </div>

                <div className="right">
                  <button
                    data-testid="showFrame"
                    onClick={() =>
                      showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                    }
                    className="api-box-coloured-button"
                  >
                    view
                  </button>
                </div>
              </div>
            )}

          {singleDoc &&
            singleDoc.color &&
            singleDoc &&
            singleDoc.color.toLowerCase() === "green" && (
              <div className="api-box-coloured green1">
                <div className="left">
                  <div className="api-box-coloured-image">
                    <img src={Green} alt="pdf" />
                  </div>
                  <div className="api-box-coloured-name">{singleDoc.name}</div>
                </div>

                <div className="right">
                  <button
                    data-testid="showFrame"
                    onClick={() =>
                      showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                    }
                    className="api-box-coloured-button"
                  >
                    view
                  </button>
                </div>
              </div>
            )}

          {singleDoc &&
            singleDoc.color &&
            singleDoc.color.toLowerCase() === "lemon" && (
              <div className="api-box-coloured lemon1">
                <div className="left">
                  <div className="api-box-coloured-image">
                    <img src={Lemon} alt="pdf" />
                  </div>
                  <div className="api-box-coloured-name">{singleDoc.name}</div>
                </div>

                <div className="right">
                  <button
                    data-testid="showFrame"
                    onClick={() =>
                      showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                    }
                    className="api-box-coloured-button"
                  >
                    view
                  </button>
                </div>
              </div>
            )}

          {singleDoc &&
            singleDoc.color &&
            singleDoc.color.toLowerCase() === "blue" && (
              <div className="api-box-coloured blue1">
                <div className="left">
                  <div className="api-box-coloured-image">
                    <img src={Blue} alt="pdf" />
                  </div>
                  <div className="api-box-coloured-name">{singleDoc.name}</div>
                </div>

                <div className="right">
                  <button
                    data-testid="showFrame"
                    onClick={() =>
                      showFrame(singleDoc.id, singleDoc.link, singleDoc.name)
                    }
                    className="api-box-coloured-button"
                  >
                    view
                  </button>
                </div>
              </div>
            )}
        </div>

        <div className="sandbox">
          <div className="sandbox-left">
            <p>Sandbox</p>
            <h2>Start Integration Now</h2>
            <button
              data-testid="go-to-product"
              disabled={singleDoc.name !== "NIBSS INSTANT PAYMENT"}
              onClick={() =>
                goToProductHome(singleDoc.id, singleDoc.link, singleDoc.name)
              }
            >
              {singleDoc.name === "NIBSS INSTANT PAYMENT"
                ? "EXPLORE"
                : "CONTACT US"}
            </button>
          </div>
          {singleDoc.name === "NIBSS INSTANT PAYMENT" && (
            <div className="sandbox-right">
              <img src={SandboxIcon} alt="sandox-icon" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Docs.propTypes = {
  singleDoc: PropTypes.object,
  showFrame: PropTypes.func,
};

export default Docs;
